<script setup>
  import {ref} from "vue";

  import ComponentAlert from "@components/Alerts/Alert.vue";
  import ComponentBarcodeScanner from "@components/BarcodeScanner/BarcodeScanner.vue";
  import ComponentBmpImportDialogRequestedPage from "@components/Dialogs/BmpImportDialog/Tabs/RequestedPage.vue";
  import {MedSpinner} from "@pharma4u/medicheck-components";
  import {Symbology} from "scandit-web-datacapture-barcode";

  defineOptions({
    name: "ComponentBmpImportDialogDeviceCameraScanTab",
  });

  defineProps({
    error: {
      type: Object,
      required: true,
    },
    requestedPage: {
      type: String,
      default: null,
    },
  });

  const emit = defineEmits(["error", "input", "skip"]);

  const formats = [Symbology.DataMatrix];

  const cameraOn = ref(false);
  const cameraDisabled = ref(false);
  const enableScan = ref(true);

  const onCameraOn = () => {
    cameraOn.value = true;
  };

  const onError = (error) => {
    emit("error", "error", error.message);
    cameraDisabled.value = true;
  };

  const onDetect = (recognizedBarcodes) => {
    if (enableScan.value && recognizedBarcodes.length === 1) {
      enableScan.value = false;
      setTimeout(() => {
        // avoid emitting input event multiple times
        enableScan.value = true;
      }, 3000);
      emit("input", recognizedBarcodes[0]._data);
    }
  };
</script>

<template>
  <div class="mt-5 flex flex-col gap-3">
    <h3 class="text-lg leading-6 font-medium text-gray-700">BMP-Datamatrix scannen</h3>

    <ComponentAlert
      v-if="error.type && error.text"
      :type="error.type"
      class="mb-0!"
      :test-id="getTestId('device-camera-scanner-tab')"
    >
      {{ error.text }}
    </ComponentAlert>

    <ComponentBmpImportDialogRequestedPage
      v-if="requestedPage"
      :requested-page="requestedPage"
      :test-id="testId + '-requested-page'"
      @skip="$emit('skip')"
    />

    <p v-else>Bitte jetzt die Datamatrix mit Ihrer Gerätekamera einlesen.</p>

    <div v-if="!cameraDisabled">
      <div v-show="!cameraOn" class="flex h-40 items-center justify-center">
        <MedSpinner size="2xl" :data-test="getTestId('device-camera-scanner-tab-spinner')" />
      </div>

      <div v-show="cameraOn">
        <ComponentBarcodeScanner
          :barcode-formats="formats"
          :test-id="getTestId('device-camera-scanner-tab')"
          @camera-on="onCameraOn"
          @error="onError"
          @detect="onDetect"
        />
      </div>
    </div>
  </div>
</template>

<style scoped></style>
